import { render, staticRenderFns } from "./DetaiAssessConfirmation.vue?vue&type=template&id=ec6440ac&"
import script from "./DetaiAssessConfirmation.vue?vue&type=script&lang=js&"
export * from "./DetaiAssessConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports